import React, { useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'

import AppRoutes from './router/AppRoutes'

import Loader from '../components/Loader'
import CustomHistoryChangeEvent from 'features/notifications/components/CustomHistoryChangeEvent'
import CustomTriggerPadPopupEvent from 'features/notifications/components/CustomTriggerPadPopupEvent'
import MaintenancePage from '../components/MaintenancePage/MaintenancePage'

import { NotificationProvider } from 'lib/firebaseNotification'
import { useMaintenanceStatus } from 'hooks/useMaintenanceStatus'

import { useAuth, useAuthStore } from 'features/auth/store/authStore'

const App = () => {
  const { role: userRole, isLoading } = useAuth()

  const { isInMaintenance } = useMaintenanceStatus()

  // Zustand's authStore is the single source of truth — hydrate once on mount.
  useEffect(() => {
    useAuthStore.getState().fetchProfile()
  }, [])

  if (isLoading) return <Loader height />
  if (isInMaintenance) return <MaintenancePage />

  return (
    <BrowserRouter>
      <CustomHistoryChangeEvent>
        <NotificationProvider>
          <CustomTriggerPadPopupEvent />
          <AppRoutes userRole={userRole} />
        </NotificationProvider>
      </CustomHistoryChangeEvent>
    </BrowserRouter>
  )
}

export default App
